import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { CandidateProAction2 } from "../../../Redux/action/CandidateProAction2";
import { CandidateProfile } from "../../../Redux/action/CandidateProfileAction";
import { CandidateUpdateProImg } from "../../../Redux/action/CandidateUpdateProImgAction";
import {
  fetchDepartmentDetails,
  fetchDesignationDetails,
  fetchSkillDetails,
} from "../../../Redux/action/MasterSkillAction";
import { useCountries } from "../../../Hooks/useCountries";
import { useStatesByCountry } from "../../../Hooks/useStatesByCountry";
import { useCitiesByState } from "../../../Hooks/useCitiesByState";
import getCroppedImg from "../../../utils/CropImg";
import { Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";
import { useNavigate } from "react-router";

import { CiEdit } from "react-icons/ci";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RiForbid2Line } from "react-icons/ri";

import {
  Box,
  Grid,
  Avatar,
  TextField,
  Typography,
  IconButton,
  Button,
  MenuItem,
  Switch,
  TextareaAutosize,
  Divider,
  Tooltip,
  FormHelperText,
  FormControl,
} from "@mui/material";

import Select from "react-select";
import dummyDp from "../../../images/dummy_dp.png";
import LanguageSection from "./LanguageSection";
import axios from "axios";

const themeColor = "#286a94";
const baseUrl = process.env.REACT_APP_API_PATH;

const UpdateProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userResult } = useSelector((state) => state.Auth);
  const userInfo = useSelector((state) => state.Profile.result);
  const [isDisabled, setIsDisabled] = useState(true);
  const [openCrop, setOpenCrop] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [image, setImage] = useState(dummyDp);
  const [tempPro, setTempPro] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropPixels, setCropPixels] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [profileInfo, setProfileInfo] = useState({
    firstName: "",
    lastName: "",
    currentDesignation: "",
    overview: "",
    keyExperience: "",
    keyExperienceInMonth: "",
    gender: "",
    state: "",
    pincode: "",
    city: "",
    country: "",
    availableForWork: false,
    department: "",
    address: "",
    skillList: [],
  });
  const AllSkillList = useSelector(
    (state) => state?.MasterTableDetails?.skill?.content
  );
  const AllDepartmentList = useSelector(
    (state) => state?.MasterTableDetails?.department?.content
  );
  const AllDesignationList = useSelector(
    (state) => state?.MasterTableDetails?.designation?.content
  );

  const candidateId = userResult?.userid;

  const [languages, setLanguages] = useState([]);

  /* Skills */
  const skillOptions = useMemo(
    () =>
      (AllSkillList || []).map((s) => ({
        label: s.skillName,
        value: s.skillName,
      })),
    [AllSkillList]
  );

  /* Departments */
  const departmentOptions = useMemo(
    () =>
      (AllDepartmentList || []).map((d) => ({
        label: d.departmentName,
        value: d.departmentName,
      })),
    [AllDepartmentList]
  );

  const onAdd = (language) => handleAddLanguage(language);
  const onEdit = (language) => handleUpdateLanguage(language);
  const onDelete = (id) => handleDeleteLanguage(id);
  const normalizeCity = (city) =>
    city?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const { data: countries } = useCountries();
  const { data: stateList } = useStatesByCountry(
    profileInfo?.country || "India"
  );
  const { data: cityData } = useCitiesByState(
    profileInfo?.country,
    profileInfo?.state
  );

  useEffect(() => {
    dispatch(CandidateProfile(candidateId));
    dispatch(fetchSkillDetails());
    dispatch(fetchDepartmentDetails());
    dispatch(fetchDesignationDetails());
    getLanguagesByCandidateId(candidateId);
  }, []);

  const getLanguagesByCandidateId = async (candidateId) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${baseUrl}/ebench/languages/candidate/${candidateId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
              userResult?.token || localStorage.getItem("token")
            }`,
          },
        }
      );

      setLanguages(response.data || []);
    } catch (error) {
      console.error("Failed to fetch languages", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteLanguage = async (id) => {
    try {
      setLoading(true);

      await axios.delete(`${baseUrl}/ebench/languages/${id}`);

      setLanguages((prev) => prev.filter((lang) => lang.languageId !== id));
      toast.success("Language deleted successfully");
    } catch (error) {
      console.error("Failed to delete language", error);
    } finally {
      setLoading(false);
    }
  };
  const handleUpdateLanguage = async (language) => {
    try {
      setLoading(true);

      const response = await axios.put(
        `${baseUrl}/ebench/languages/${language.languageId}`,
        language
      );
      setLanguages((prev) =>
        prev.map((l) =>
          l.languageId === language.languageId ? response.data : l
        )
      );
      toast.success("Language updated successfully");
    } catch (error) {
      console.error("Failed to update language", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddLanguage = async (language) => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${baseUrl}/ebench/languages/candidate/${candidateId}`,
        language
      );
      setLanguages((prev) => [...prev, response.data]);
      toast.success("Language added successfully");
    } catch (error) {
      console.error("Failed to add language", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (image?.startsWith("blob:")) {
        URL.revokeObjectURL(image); // for multiple updates profile picture removing previous picture.
      }
    };
  }, [image]);

  useEffect(() => {
    if (userInfo) {
      setProfileInfo({
        ...userInfo,
        keyExperience: userInfo?.keyExperience,
        keyExperienceInMonth: userInfo?.keyExperienceInMonth,
      });

      setSelectedSkills(
        userInfo?.skillList?.map((item) => ({ label: item, value: item })) || []
      );

      setImage(userInfo?.profileImageUrl || dummyDp);
    }
  }, [userInfo]);

  const handleChange = (e) =>
    setProfileInfo((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSkillsChange = (skills) => {
    setSelectedSkills(skills);
    setProfileInfo({ ...profileInfo, skillList: skills.map((s) => s.value) });
  };

  const fileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return toast.error("Upload an image");
    const sizeMB = file.size / (1024 * 1024);
    if (sizeMB > 2 || sizeMB < 0.004)
      return toast.error(
        "Please upload a file larger than 4 KB and smaller than 2 MB."
      );

    const reader = new FileReader();
    reader.onloadend = () => {
      setTempPro(reader.result);
      setOpenCrop(true);
    };
    reader.readAsDataURL(file);
  };

  const handleCropSubmit = async () => {
    const croppedFile = await getCroppedImg(tempPro, cropPixels);
    const previewUrl = URL.createObjectURL(croppedFile);
    const formData = new FormData();
    formData.append("image", croppedFile);
    formData.append("candidateId", candidateId);
    dispatch(CandidateUpdateProImg(formData)).then((res) => {
      if (previewUrl) {
        setImage(previewUrl); // show profile picture instantly
      }
      setOpenCrop(false);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("candidateReqDto", JSON.stringify(profileInfo));
    if (!validateProfile()) {
      toast.error(
        "Some fields are missing or invalid. Please review your information."
      );
      return;
    }
    await dispatch(CandidateProAction2(formData, navigate));
    setIsDisabled(true);
  };

  const validateProfile = () => {
    const MIN_LENGTH = 2; //For FirstName/LastName
    const MAX_LENGTH = 50; //For FirstName/LastName
    const maxAddressLength = 70; //For Address

    let newErrors = {};

    const requiredFields = [
      "firstName",
      "lastName",
      "currentDesignation",
      "gender",
      "department",
      "country",
      "state",
      "city",
      "pincode",
      "address",
      "keyExperience",
      "overview",
    ];

    requiredFields.forEach((field) => {
      const value = profileInfo[field];

      if (
        value === "" ||
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "")
      ) {
        const formattedField = field
          .replace(/([A-Z])/g, " $1")
          .trim()
          .replace(/^./, (c) => c.toUpperCase());

        newErrors[field] = `${formattedField} is required`;
      }
    });

    if (!profileInfo.skillList || profileInfo.skillList.length === 0) {
      newErrors.skillList = "At least one skill is required";
    }

    if (!tempPro && !userInfo?.profileImageUrl) {
      newErrors.profilePicture = "Profile Picture is required";
    }
    if (profileInfo.firstName) {
      if (!/^[A-Za-z\s]+$/.test(profileInfo.firstName)) {
        newErrors.firstName = "First name must contain only letters";
      } else if (profileInfo.firstName.length < MIN_LENGTH) {
        newErrors.firstName = `First name must be at least ${MIN_LENGTH} characters long`;
      } else if (profileInfo.firstName.length > MAX_LENGTH) {
        newErrors.firstName = `First name cannot exceed ${MAX_LENGTH} characters`;
      }
    }

    if (profileInfo.lastName) {
      if (!/^[A-Za-z\s]+$/.test(profileInfo.lastName)) {
        newErrors.lastName = "Last name must contain only letters";
      } else if (profileInfo.lastName.length < MIN_LENGTH) {
        newErrors.lastName = `Last name must be at least ${MIN_LENGTH} characters long`;
      } else if (profileInfo.lastName.length > MAX_LENGTH) {
        newErrors.lastName = `Last name cannot exceed ${MAX_LENGTH} characters`;
      }
    }

    if (profileInfo.overview && profileInfo.overview.length < 30) {
      newErrors.overview = "Overview must be at least 30 characters";
    }

    if (profileInfo.pincode && !/^\d{5,10}$/.test(profileInfo.pincode)) {
      newErrors.pincode = "Pincode must be 5–10 digits";
    }

    if (profileInfo.address) {
      if (profileInfo.address.length < 5) {
        newErrors.address = "Address must be at least 5 characters long";
      } else if (profileInfo.address.length > maxAddressLength) {
        newErrors.address = `Address must not exceed ${maxAddressLength} characters`;
      }
    } else {
      newErrors.address = "Address is required";
    }
    setErrors(newErrors);
    console.log(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const selectStyles = useMemo(
    () => ({
      container: (base) => ({
        ...base,
        backgroundColor: "#fff",
      }),

      control: (base) => ({
        ...base,
        backgroundColor: "#fff",
        borderRadius: 10,
        padding: 6,
        borderColor: Boolean(errors.skillList) ? "red" : themeColor,
        boxShadow: "none",
        "&:hover": {
          borderColor: Boolean(errors.skillList) ? "red" : themeColor,
        },
      }),

      menu: (base) => ({
        ...base,
        backgroundColor: "#fff",
        zIndex: 9999,
      }),

      menuList: (base) => ({
        ...base,
        backgroundColor: "#fff",
      }),

      multiValue: (base) => ({
        ...base,
        backgroundColor: themeColor,
        color: "#fff",
        fontWeight: 600,
      }),

      multiValueLabel: (base) => ({
        ...base,
        color: "#fff",
      }),

      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? themeColor : "#fff",
        color: state.isSelected ? "#fff" : "#000",
        "&:hover": {
          backgroundColor: themeColor,
          color: "#fff",
        },
      }),
    }),
    [errors.skillList, themeColor]
  );

  return (
    <>
      {/* Cropper Modal */}
      <Modal show={openCrop} onHide={() => setOpenCrop(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: 400 }}>
          <Cropper
            image={tempPro}
            crop={crop}
            zoom={zoom}
            cropShape="round"
            onCropChange={setCrop}
            onCropComplete={(area, pixelArea) => setCropPixels(pixelArea)}
            onZoomChange={setZoom}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            sx={{ bgcolor: themeColor }}
            variant="contained"
            onClick={handleCropSubmit}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------- MAIN CONTENT ------- */}
      <Box sx={{ maxWidth: "900px", mx: "auto", p: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ color: themeColor }}
            >
              Profile Settings
            </Typography>

            <Tooltip title={isDisabled ? "Edit Profile" : "Disable Editing"}>
              <IconButton
                sx={{
                  backgroundColor: isDisabled ? "#e3eefc" : "#ffe2e2",
                  "&:hover": {
                    backgroundColor: isDisabled ? "#c9ddfa" : "#ffcccc",
                  },
                  transition: "background-color 0.3s ease",
                }}
                onClick={() => setIsDisabled(!isDisabled)}
              >
                {isDisabled ? (
                  <CiEdit size={22} />
                ) : (
                  <RiForbid2Line size={22} color="red" />
                )}
              </IconButton>
            </Tooltip>
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: "red",
              mt: { xs: 0.5, sm: 0 },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Fields marked with * are required
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />
        {/* ========= SECTION: PROFILE IMAGE ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Profile Picture <span style={{ color: "red", marginLeft: 4 }}>*</span>
        </Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={4} textAlign="center">
            <div style={{ textAlign: "center" }}>
              <Avatar
                src={image}
                imgProps={{
                  loading: "eager",
                  decoding: "async",
                }}
                sx={{
                  width: 150,
                  height: 150,
                  mx: "auto",
                  border: `3px solid ${themeColor}`,
                }}
              />

              {errors.profilePicture && (
                <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                  {errors.profilePicture}
                </Typography>
              )}
            </div>

            {!isDisabled && (
              <Button
                component="label"
                variant="outlined"
                sx={{ mt: 2, borderColor: themeColor, color: themeColor }}
                startIcon={<IoCloudUploadOutline />}
              >
                Upload
                <input hidden type="file" onChange={fileChange} />
              </Button>
            )}
          </Grid>
        </Grid>

        {/* ========= PERSONAL INFORMATION ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Personal Information
        </Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="First Name"
              required
              disabled={isDisabled}
              name="firstName"
              value={profileInfo.firstName}
              onChange={handleChange}
              error={Boolean(errors.firstName)}
              helperText={errors.firstName}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Last Name"
              required
              disabled={isDisabled}
              name="lastName"
              error={Boolean(errors.lastName)}
              helperText={errors.lastName}
              value={profileInfo.lastName}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    fontSize: "20px",
                    color: "red",
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Gender"
              name="gender"
              error={Boolean(errors.gender)}
              helperText={errors.gender}
              value={profileInfo.gender}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={{ mb: 1, fontWeight: 600, color: themeColor }}>
              Professional Summary <span style={{ color: "red" }}>*</span>
            </Typography>

            <FormControl fullWidth error={Boolean(errors.overview)}>
              <TextareaAutosize
                minRows={4}
                disabled={isDisabled}
                name="overview"
                placeholder="Write a short professional summary..."
                value={profileInfo.overview}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "14px",
                  border: Boolean(errors.overview)
                    ? "1px solid red"
                    : "1px solid #ccc",
                  borderRadius: 6,
                  fontSize: "16px",
                  fontFamily: "Roboto, sans-serif",
                  boxSizing: "border-box",
                }}
              />

              {errors.overview && (
                <FormHelperText>{errors.overview}</FormHelperText>
              )}
            </FormControl>
          </Grid>
        </Grid>

        {/* ========= PROFESSIONAL ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Professional Details
        </Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Designation"
              name="currentDesignation"
              error={Boolean(errors.currentDesignation)}
              helperText={errors.currentDesignation}
              value={profileInfo.currentDesignation}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              {AllDesignationList?.map((d) => (
                <MenuItem key={d.designationId} value={d.designation}>
                  {d.designation}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Department"
              name="department"
              error={Boolean(errors.department)}
              helperText={errors.department}
              value={profileInfo.department}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              {departmentOptions?.map((d) => (
                <MenuItem key={d.departmentId} value={d.value}>
                  {d.value}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Experience (Years)"
              name="keyExperience"
              error={Boolean(errors.keyExperience)}
              helperText={errors.keyExperience}
              value={String(profileInfo.keyExperience)?.replace(/[^0-9]/g, "")}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  keyExperience: e.target.value,
                })
              }
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              {[...Array(31)].map((_, i) => (
                <MenuItem key={i} value={i}>
                  {i} Years
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              disabled={isDisabled}
              label="Experience (Months)"
              name="keyExperienceInMonth"
              value={String(profileInfo.keyExperienceInMonth)?.replace(
                /[^0-9]/g,
                ""
              )}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  keyExperienceInMonth: e.target.value,
                })
              }
            >
              {[...Array(12)].map((_, i) => (
                <MenuItem key={i} value={i}>
                  {i} Months
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        {/* ========= SKILLS ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Skills <span style={{ color: "red" }}>*</span>
        </Typography>

        <FormControl fullWidth error={Boolean(errors.skillList)} sx={{ mt: 2 }}>
          <Select
            isMulti
            isDisabled={isDisabled}
            value={selectedSkills}
            onChange={handleSkillsChange}
            options={skillOptions}
            styles={selectStyles}
          />

          {errors.skillList && (
            <FormHelperText sx={{ color: "red", mt: 0.5 }}>
              {errors.skillList}
            </FormHelperText>
          )}
        </FormControl>

        {/* ========= LOCATION ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mt: 4, mb: 2, color: themeColor }}
        >
          Location
        </Typography>

        <Grid container spacing={2} mb={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              disabled={isDisabled}
              label="Address"
              name="address"
              value={profileInfo.address}
              error={Boolean(errors.address)}
              helperText={errors.address}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="Country"
              name="country"
              error={Boolean(errors.country)}
              helperText={errors.country}
              value={profileInfo.country}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  country: e.target.value,
                  state: "",
                  city: "",
                })
              }
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              {countries?.data?.map((c) => (
                <MenuItem key={c.country} value={c.country}>
                  {c.country}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="State"
              name="state"
              error={Boolean(errors.state)}
              helperText={errors.state}
              value={profileInfo.state}
              onChange={(e) =>
                setProfileInfo({
                  ...profileInfo,
                  state: e.target.value,
                  city: "",
                })
              }
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              {stateList?.data?.states?.map((s) => (
                <MenuItem key={s.name} value={s.name}>
                  {s.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              select
              fullWidth
              required
              disabled={isDisabled}
              label="City"
              name="city"
              error={Boolean(errors.city)}
              helperText={errors.city}
              value={profileInfo.city}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            >
              {[
                ...new Map(
                  (cityData || []).map((city) => [normalizeCity(city), city])
                ).entries(),
              ].map(([normalized, original]) => (
                <MenuItem key={normalized} value={original}>
                  {normalized}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              required
              disabled={isDisabled}
              label="Pincode"
              name="pincode"
              error={Boolean(errors.pincode)}
              helperText={errors.pincode}
              value={profileInfo.pincode}
              onChange={handleChange}
              InputLabelProps={{
                sx: {
                  "& .MuiFormLabel-asterisk": {
                    color: "red",
                  },
                },
              }}
            />
          </Grid>
        </Grid>

        {/* ========= TOGGLE ========= */}
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Preferences
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Typography>Available for work</Typography>
          <Switch
            disabled={isDisabled}
            checked={profileInfo.availableForWork}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#2d6d96",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#2d6d96",
              },
            }}
            onChange={() =>
              setProfileInfo({
                ...profileInfo,
                availableForWork: !profileInfo.availableForWork,
              })
            }
          />
        </Box>
        <Divider sx={{ my: 2 }} />

        {/* ========= LANGUAGES SECTION ========= */}
        {/* <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ mb: 2, color: themeColor }}
        >
          Languages
        </Typography> */}

        <Box>
          <LanguageSection
            languages={languages}
            onAdd={onAdd}
            onEdit={onEdit}
            onDelete={onDelete}
            isDisabled={isDisabled}
          />
        </Box>

        {!isDisabled && (
          <Button
            sx={{
              mt: 4,
              bgcolor: themeColor,
              ":hover": { bgcolor: "#1f5678" },
            }}
            variant="contained"
            onClick={handleSubmit}
          >
            Save Changes
          </Button>
        )}
      </Box>
    </>
  );
};

export default UpdateProfile;
